import apiService from './apiService'

const requestPromoEventsList = () => {
  return apiService.get(URIS.promoEvents)
}

const requestToggleEventStatus = (eventId, togglePayload) => {
  return apiService.patch(URIS_D('togglePromoEvent', eventId), togglePayload)
}

const requestPromoEventCreation = (eventPayload) => {
  return apiService.post(URIS.promoEvents, eventPayload)
}

const requestEventDoctorAssociation = (eventId) => {
  return apiService.get(URIS_D('togglePromoEvent', eventId))
}

const requestDoctorsAssociation = (eventId, payload) => {
  return apiService.put(URIS_D('addDoctorToEvent', eventId),payload) 
}


export {
  requestPromoEventsList,
  requestToggleEventStatus,
  requestPromoEventCreation,
  requestEventDoctorAssociation,
  requestDoctorsAssociation
}

const URIS_D = (url, param1) => {
  return {
    togglePromoEvent: `/admin/promotional-events/${param1}`,
    addDoctorToEvent: `/admin/promotional-events/${param1}/doctors`
  }[url]
}

const URIS = {
  promoEvents: '/admin/promotional-events',
}
